import { useEffect, useRef } from 'react';
import { useCrmData } from '../../contexts/CrmDataContext';
import { useCrmPageNotifications } from '../../contexts/CrmPageNotificationsContext';
import { pageFeedbackToToast } from '../../lib/pageFeedbackToast';

export function DataStatusBanner() {
  const { error, usersLoadWarning, loading } = useCrmData();
  const { push } = useCrmPageNotifications();
  const lastErrorRef = useRef<string | null>(null);

  useEffect(() => {
    if (error && error !== lastErrorRef.current) {
      lastErrorRef.current = error;
      push(pageFeedbackToToast({ kind: 'error', title: 'Data load error', message: error }));
    }
    if (!error) lastErrorRef.current = null;
  }, [error, push]);

  if (loading && !error && !usersLoadWarning) return null;
  if (!error && !usersLoadWarning) return null;

  return (
    <div className="data-banner" role="status">
      {error && <p className="data-banner__error">{error}</p>}
      {usersLoadWarning && <p className="data-banner__warn">{usersLoadWarning}</p>}
    </div>
  );
}
